/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The type of identity associated with the card holder. Must be either "individual" or "corporate".
 */
export type CardAccountIdentityType = typeof CardAccountIdentityType[keyof typeof CardAccountIdentityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountIdentityType = {
  individual: 'individual',
  corporate: 'corporate',
} as const;
